import {Component, OnInit, ViewChild} from '@angular/core';
import {
  MotifNonConformiteSavedSupplier,
  MotifsNonConformiteService
} from '../../core/services/entities/motifs-non-conformite.service';
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from "../../core/constants";
import {saveAs} from "file-saver";
import {confirm} from "devextreme/ui/dialog";
import {ResponseWrapper} from "../../core/suppliers/wrappers/response-wrapper";
import {IsDeletableObject} from "../../core/models/is-deletable-object";
import {Auth2Service} from "../../core/services/security/auth2.service";
import {InternationalizationService} from "../../core/services/i8n/i8n.service";
import {GraphQLService} from "../../core/services/technique/graphql.service";
import {UtilsService} from "../../core/utils/utils.service";
import {ToastService} from "../../core/services/technique/toast.service";
import {OverlayPanel} from "primeng/overlaypanel";
import {Subscription} from "rxjs";
import {MotifNonConformiteDTO} from "../../core/dtos/motif-non-conformite-dto";

@Component({
  selector: 'yo-motifs-non-conformite',
  templateUrl: './motifs-non-conformite.component.html',
  styleUrls: ['./motifs-non-conformite.component.scss']
})
export class MotifsNonConformiteComponent implements OnInit {

  @ViewChild('opImportXls') opImportXls: OverlayPanel;

  subLog: Subscription;
  subMotifNonConformiteSaved: Subscription;
  subMotifsNonConformite: Subscription;
  importSub: Subscription;
  exportSub: Subscription;
  deleteSub: Subscription;

  logged: boolean = false;

  motifsNonConformite: MotifNonConformiteDTO[] = [];

  selectedRows: number[] = [];
  errors: any[] = [];

  displayImportPopupErrors: boolean = false;
  displayDeletePopupErrors: boolean = false;


  pathHelpFile: string = HELP_FOLDERS.REFERENTIEL + '/motifs-non-conformite/motifs-non-conformite';

  constructor(public motifsNonConformiteSvc: MotifsNonConformiteService,
              private auth2Svc: Auth2Service,
              private i8nSvc: InternationalizationService,
              private graphQlSvc: GraphQLService,
              public utilsSvc: UtilsService,
              public toastSvc: ToastService) {
  }

  ngOnInit() {
    this.initLoggedSubscription();
    this.initMotifsNonConformiteSubscription();
    this.initMotifNonConformiteSavedSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subLog);
    this.utilsSvc.unsubscribe(this.subMotifNonConformiteSaved);
    this.utilsSvc.unsubscribe(this.subMotifsNonConformite);
    this.utilsSvc.unsubscribe(this.importSub);
    this.utilsSvc.unsubscribe(this.exportSub);
    this.utilsSvc.unsubscribe(this.deleteSub);
  }

  initLoggedSubscription = (): void => {
    this.subLog = this.auth2Svc.isLoggedIn$
      .subscribe(res => this.logged = res);
  }

  initMotifsNonConformiteSubscription = (): void => {
    const idsSites: number[] = this.auth2Svc.utilisateur.sites.map(s => s.id);
    this.subMotifsNonConformite = this.graphQlSvc.sendQuery(`
      {
        allMotifsNonConformite(filters: {
          siteIds: [${idsSites}]
        }) {
            id,
            code,
            libelle,
            actif,
            site {
                id,
                libelle,
            },
        }
      }
    `)
      .subscribe((response: any) => {
        this.motifsNonConformite = response.allMotifsNonConformite;
      });
  }

  initMotifNonConformiteSavedSubscription = (): void => {
    this.subMotifNonConformiteSaved = this.motifsNonConformiteSvc.motifNonConformiteSaved$
      .subscribe((response: MotifNonConformiteSavedSupplier) => {
        if (response.isUpdate) {
          const idx: number = this.motifsNonConformite.findIndex(motifNonConformite => motifNonConformite.id === response.motifNonConformite.id);
          this.motifsNonConformite[idx] = response.motifNonConformite;
        } else {
          this.motifsNonConformite.push(response.motifNonConformite);
        }
      });
  };

  openDialogEdition = (motifNonConformite: MotifNonConformiteDTO): void => {
    this.motifsNonConformiteSvc.announceOpenDialogEdition(motifNonConformite);
  };

  calculateSiteValue = (motifNonConformite: MotifNonConformiteDTO): String => {
    return motifNonConformite?.site?.libelle
  };

  exportXslx = () => {
    this.exportSub = this.motifsNonConformiteSvc.exportMotifNonConformiteByFilters(this.selectedRows).subscribe(response => {
      const filename = `motifNonConformite-export-${new Date().getTime()}.xlsx`;
      const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
      this.selectedRows = [];
      saveAs(blob, filename);
    });
  }

  importXslx = async ($event: any) => {
    this.errors = [];
    if ($event.target.files && $event.target.files.length) {
      const file: File = $event.target.files[0];
      this.opImportXls.hide();
      this.importSub = this.motifsNonConformiteSvc.importMotifNonConformiteFromXlsx(file)
        .subscribe(response => {
          const res: any = response.one;
          if (res.allElementsImported)
            this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Le fichier a été importé avec succès`);
          else {
            for (const item of Object.entries(res.reports)) {
              let values: any[] = Array.of(item[1]);
              const labelsError: any[] = values.map(val => val.map(v => this.i8nSvc.getLabelFromCode(v.code, v.args.split(','))).join(', '));
              this.errors.push({infosLine: item[0], labelsError});
            }
          }
          for (const item of res.elementsImported) {
            let index = this.motifsNonConformite.findIndex(motifNonConformite => motifNonConformite.id == item.id);
            if (index >= 0)
              this.motifsNonConformite[index] = item;
            else
              this.motifsNonConformite.push(item)
          }

          if (this.errors != null && this.errors.length > 0)
            this.displayImportErrors();
        });
    }
  }

  displayImportErrors = (): void => {
    this.displayImportPopupErrors = true;
  }

  displayDeleteErrors = (): void => {
    this.displayDeletePopupErrors = true;
  }

  closeErrors = (): void => {
    this.errors = [];
    this.displayImportPopupErrors = false;
    this.displayDeletePopupErrors = false;
  }

  deleteValues = async (): Promise<void> => {
    this.errors = [];
    let idsToDeleteInTable = Object.assign([], this.selectedRows);

    let isDeletionValidated: boolean = await confirm(this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? "CONFIRM_DELETION_PLURAL" : "CONFIRM_DELETION_SINGULAR", null), this.i8nSvc.getLabelFromCode("Suppression", null));

    if (!isDeletionValidated)
      return new Promise(null);

    this.deleteSub = this.motifsNonConformiteSvc.deleteMotifNonConformiteByFilters(this.selectedRows).subscribe(response => {
      const res: any = (response as ResponseWrapper<IsDeletableObject>).one;

      if (res) {
        if (res.messagesErrorList && res.messagesErrorList.length > 0) {
          for (const error of res.messagesErrorList) {
            const infosLine: string = this.i8nSvc.getLabelFromCode(error.code, error.args.split(','));
            this.errors.push({infosLine});
            const elementToKeep = this.motifsNonConformite.find(motifNonConformite => motifNonConformite.code === error.args);
            idsToDeleteInTable = idsToDeleteInTable.filter(id => elementToKeep.id !== id);
          }
          this.displayDeleteErrors();
        } else {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? `MOTIF_NON_CONFORMITE_DELETION_COMPLETED_PLURAL` : `MOTIF_NON_CONFORMITE_DELETION_COMPLETED_SINGULAR`, null));
        }
        this.motifsNonConformite = this.motifsNonConformite.filter(motifNonConformite => !idsToDeleteInTable.find(id => id === motifNonConformite.id));
      }
    });
  }

  canDelete = (): boolean => this.selectedRows.length > 0;


}
